import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosAtheneum } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  createOrder,
  deleteOrder,
  getOneOrder,
  getOrder,
} from '../../utils/apiRoutes';

// export const getAllOrderAsync = async () => {
//   // createAsyncThunk(`${moduleName}/getAllOrderAsync`,
//   // async (payload) => {
//   const response = await axiosAtheneum({
//     method: 'GET',
//     url: getOrder(),
//   });
//   const data = response.data;
//   return data;
//   // });
// };

export const getAllOrderAsync = createAsyncThunk(
  `${moduleName}/getAllOrderAsync`,
  async (payload) => {
    const { params } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: getOrder(),
      params: { ...params },
    });
    const data = response.data;
    return data;
  }
);

export const postOrdersAsync = createAsyncThunk(
  `${moduleName}/postOrdersAsync`,
  async (payload) => {
    const response = await axiosAtheneum({
      method: 'POST',
      url: createOrder(),
      data: payload,
    });
    const data = response.data;
    return data;
    // return response.data;
  }
);

export const getOneOrderAsync = createAsyncThunk(
  `${moduleName}/getOneOrderAsync`,
  async (payload) => {
    const { _id } = payload;
    const response = await axiosAtheneum({
      method: 'GET',
      url: getOneOrder(_id),
    });
    const data = response.data;
    return data;
  }
);

export const deleteOneOrderAsync = createAsyncThunk(
  `${moduleName}/deleteOneOrderAsync`,
  async (_id) => {
    console.log(_id);
    const response = await axiosAtheneum({
      method: 'DELETE',
      url: deleteOrder(_id),
    });
    const data = response.data;
    return data;
  }
);

const OrderSlice = createSlice({
  name: `${moduleName}/Order`,
  initialState: {
    loading: false,
    Order: [],
    oneorder: [],
    postorder: null,
  },
  reducers: {},
  extraReducers: {
    [getAllOrderAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getAllOrderAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.Order = action.payload;
    },
    [getAllOrderAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [getOneOrderAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getOneOrderAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneorder = action.payload;
    },
    [getOneOrderAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [postOrdersAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [postOrdersAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.postorder = action.payload;
    },
    [postOrdersAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    //delete one user
    [deleteOneOrderAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteOneOrderAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.oneorder = action.payload;
    },
    [deleteOneOrderAsync.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export default OrderSlice.reducer;
